import {useEffect, useState} from "react";
import * as Y from "yjs";
import {createYjsProvider} from "../core";
import {initYMaps} from "../yMaps/initYMaps";

/**
 * Sets up and owns the Yjs collaboration primitives for a document session.
 */
export function useYjsConnection({documentId, user, websocketUrl}) {
    const [connection, setConnection] = useState(null);

    useEffect(() => {
        if (!documentId) {
            setConnection(null);
            return undefined;
        }

        const ydoc = new Y.Doc();
        const yDocMeta = ydoc.getMap("documentMeta");
        const {yReferenceMarks, yComments, ySourcePackage, yAgenticSections} = initYMaps(ydoc);

        const provider = createYjsProvider({
            documentId,
            ydoc,
            user,
            websocketUrl,
        });

        setConnection({
            ydoc,
            yDocMeta,
            yReferenceMarks,
            yComments,
            ySourcePackage,
            yAgenticSections,
            provider,
        });

        return () => {
            provider.destroy();
            ydoc.destroy();
            setConnection(null);
        };
    }, [documentId, user, websocketUrl]);

    return connection;
}
